var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('br'),_c('div',{staticClass:"form-buttons"},[_c('button',{staticClass:" newPlaceForBttn",on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("CLOSE")])])])}
var staticRenderFns = []

export { render, staticRenderFns }